import { useState } from "react";

import { translate } from "@utils";
import { useDebounce } from "@shared/hooks";
import { searchCveIds, searchProducts, searchVendors } from "@modules/cve/data";

import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import LinearProgress from "@mui/material/LinearProgress";

export const PolicyFormAddToList = ({ viewOnly = false, activePolicy, setActivePolicy, type }) => {
	const [searchStr, setSearchStr] = useState("");
	const [options, setOptions] = useState(activePolicy[type]);
	const [loading, setLoading] = useState(false);

	const searchMethods = {
		cveIds: searchCveIds,
		products: searchProducts,
		vendors: searchVendors,
	};

	const handleSearch = async () => {
		let { data, error } = await searchMethods[type](searchStr);
		if (error) console.error(error);
		if (data.length) setOptions(filterOptions({ searchStr, prevOptions: options, newOptions: data, currentSelection: activePolicy[type] }));
		setLoading(false);
	};

	const debouncedSearch = useDebounce(handleSearch);

	const handleInput = (e) => {
		setLoading(true);
		let value = e.target.value;
		setSearchStr(value);
		debouncedSearch();
	};

	return (
		<div>
			<Autocomplete
				disablePortal
				disabled={viewOnly}
				options={options}
				value={activePolicy[type]}
				renderInput={(params) => <TextField {...params} label={type} onChange={handleInput} />}
				noOptionsText={!options.length && loading ? translate("loading") : translate("search_for_options")}
				onClose={() => setOptions(activePolicy[type])}
				disableCloseOnSelect={true}
				filterOptions={(options, state) => filterOptions({ searchStr: state.inputValue, prevOptions: options, currentSelection: activePolicy[type] })}
				onChange={(e, newList) => {
					setActivePolicy((prevState) => {
						return { ...prevState, [type]: newList };
					});
				}}
				limitTags={2}
				multiple
			/>
			{loading && (
				<div style={{ position: "relative", top: "-5px", display: "flex", justifyContent: "center", height: 0 }}>
					<LinearProgress sx={{ margin: "0 2px", borderRadius: "100px", width: "100%" }} />
				</div>
			)}
		</div>
	);
};

const filterOptions = ({ searchStr, prevOptions, currentSelection, newOptions = [] }) => {
	let retainedPrevOptions = prevOptions.filter((opt) => opt.toLowerCase().includes(searchStr.toLowerCase()));
	return [...new Set([...newOptions, ...currentSelection, ...retainedPrevOptions].sort())];
};
